import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { ErrorBoundary } from './components/ErrorBoundary.tsx'

const topLevelFallback = (
  <div style={{ padding: '2rem', fontFamily: 'monospace' }}>
    <p>something went wrong.</p>
    <button type="button" onClick={() => window.location.reload()}>reload</button>
  </div>
)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary fallback={topLevelFallback}>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
